import $ from 'jquery'

$.extend(true, $.magnificPopup.defaults, {
  tClose: 'Schließen (Esc)',
  tLoading: 'Laden...',
  gallery: {
    tPrev: 'Vorherige',
    tNext: 'Nächste',
    tCounter: '%curr% von %total%'
  }
})

$('.js-gallery').magnificPopup({
  delegate: 'a',
  type: 'image',
  closeOnContentClick: false,
  closeBtnInside: false,
  mainClass: 'mfp-with-zoom mfp-img-mobile',
  image: {
    verticalFit: true,
    titleSrc: item => item.el.attr('title')
  },
  gallery: {
    enabled: true
  },
  zoom: {
    enabled: true,
    duration: 300,
    opener: element => element.find('img')
  }
})
